import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { NgTemplateOutlet } from '@angular/common';
import { ShActionItemComponent } from '../../../../elements/components/action-item/action-item.component';
import { ActionItem } from '../../../../elements/components/action-item/entities/action-item.entity';
import { FormGroupStyling } from '../../../entities/form-group-styling.entity';
import { ShFormLabelComponent } from '../form-label/form-label.component';
import { LabelIcon } from '../form-label/label-icon.entity';

@Component({
    selector: 'sh-form-group',
    templateUrl: './form-group.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ShFormLabelComponent, NgTemplateOutlet, ShActionItemComponent]
})
export class ShFormGroupComponent {
    @Input() helpText!: string;
    @Input() label!: string;
    @Input() labelIcons: LabelIcon[] = [];
    @Input() invalid!: boolean;
    @Input() required!: boolean;
    @Input() formGroupStyling: FormGroupStyling[] = [];
    @Input() id!: string;
    @Input() currentActionItems!: ActionItem[];
    @Input() labelActionItems!: ActionItem[];
    @Input() describeLabelId!: string;
    @Input() errorMsg!: string;
}
